var map = {
	"./AC.png": "da46",
	"./AD.png": "d0f6",
	"./AE.png": "8a91",
	"./AF.png": "ee2b",
	"./AG.png": "03af",
	"./AI.png": "1ddd",
	"./AL.png": "fd61",
	"./AM.png": "6ccf",
	"./AO.png": "4ff8",
	"./AQ.png": "7200",
	"./AR.png": "74f3",
	"./AS.png": "e7d9",
	"./AT.png": "d4bb",
	"./AU.png": "fd6a",
	"./AW.png": "4871",
	"./AX.png": "4ca0",
	"./AZ.png": "4b2d",
	"./BA.png": "81f3",
	"./BB.png": "33c4",
	"./BD.png": "6fc9",
	"./BE.png": "fb5c",
	"./BF.png": "f3c3",
	"./BG.png": "ee96",
	"./BH.png": "87d7",
	"./BI.png": "1725",
	"./BJ.png": "43a4",
	"./BL.png": "1305",
	"./BM.png": "82a5",
	"./BN.png": "3543",
	"./BQ.png": "378b",
	"./BR.png": "a61b",
	"./BS.png": "014d",
	"./BT.png": "e2c9",
	"./BV.png": "0810",
	"./BW.png": "1f79",
	"./BY.png": "4bc6",
	"./BZ.png": "a5c7",
	"./CA.png": "3681",
	"./CC.png": "d78f",
	"./CD.png": "42a4",
	"./CEFTA.png": "5928",
	"./CF.png": "d989",
	"./CG.png": "14c2",
	"./CH.png": "a880",
	"./CI.png": "946c",
	"./CK.png": "a0c1",
	"./CL.png": "f835",
	"./CM.png": "9ea3",
	"./CN.png": "dbb5",
	"./CO.png": "72eb",
	"./CP.png": "657c",
	"./CR.png": "f1ba",
	"./CU.png": "784b",
	"./CV.png": "69c7",
	"./CW.png": "6d12",
	"./CX.png": "ec3c",
	"./CY.png": "d5a1",
	"./CZ.png": "2ada",
	"./DE.png": "866a",
	"./DG.png": "57f6",
	"./DJ.png": "462e",
	"./DK.png": "4baf",
	"./DM.png": "bdee",
	"./DO.png": "d2af",
	"./DZ.png": "6991",
	"./EA.png": "9b18",
	"./EC.png": "afdd",
	"./EE.png": "bedf",
	"./EG.png": "d6c9",
	"./EH.png": "3d2b",
	"./ER.png": "be4e",
	"./ES-CT.png": "1420",
	"./ES-GA.png": "6964",
	"./ES.png": "1dea",
	"./ET.png": "3a14",
	"./EU.png": "61ec",
	"./FI.png": "312e",
	"./FJ.png": "ffa7",
	"./FK.png": "e616",
	"./FM.png": "bc36",
	"./FO.png": "091b",
	"./FR.png": "17d1",
	"./GA.png": "9111",
	"./GB-ENG.png": "be9f",
	"./GB-SCT.png": "ba55",
	"./GB-WLS.png": "b25d",
	"./GB.png": "15da",
	"./GD.png": "2a7f",
	"./GE.png": "9241",
	"./GF.png": "294a",
	"./GG.png": "b995",
	"./GH.png": "106d",
	"./GI.png": "1dc6",
	"./GL.png": "defe",
	"./GM.png": "7c62",
	"./GN.png": "b6f9",
	"./GP.png": "db3e",
	"./GQ.png": "9daf",
	"./GR.png": "0153",
	"./GS.png": "0e54",
	"./GT.png": "7a8e",
	"./GU.png": "9a34",
	"./GW.png": "2878",
	"./GY.png": "4aa3",
	"./HK.png": "90a8",
	"./HM.png": "f103",
	"./HN.png": "c4c8",
	"./HR.png": "d720",
	"./HT.png": "6557",
	"./HU.png": "8696",
	"./IC.png": "7162",
	"./ID.png": "b7e7",
	"./IE.png": "3b5e",
	"./IL.png": "31c5",
	"./IM.png": "0a30",
	"./IN.png": "0c9e",
	"./IO.png": "f3ea",
	"./IQ.png": "ca00",
	"./IR.png": "28e2",
	"./IS.png": "c72f",
	"./IT.png": "0bb8",
	"./JE.png": "de9f",
	"./JM.png": "7f97",
	"./JO.png": "3d46",
	"./JP.png": "491f",
	"./KE.png": "ab3a",
	"./KG.png": "b506",
	"./KH.png": "dcd9",
	"./KI.png": "fa59",
	"./KM.png": "748d",
	"./KN.png": "38bf",
	"./KP.png": "6b85",
	"./KR.png": "ac2f",
	"./KW.png": "51e9",
	"./KY.png": "e2ed",
	"./KZ.png": "3329",
	"./LA.png": "4e67",
	"./LB.png": "2841",
	"./LC.png": "1926",
	"./LI.png": "e2a0",
	"./LK.png": "7284",
	"./LR.png": "d6eb",
	"./LS.png": "2729",
	"./LT.png": "2073",
	"./LU.png": "9fe1",
	"./LV.png": "d315",
	"./LY.png": "6ba6",
	"./MA.png": "e2ab",
	"./MC.png": "1383",
	"./MD.png": "1e92",
	"./ME.png": "5a88",
	"./MF.png": "e8a8",
	"./MG.png": "617d",
	"./MH.png": "ffb7",
	"./MK.png": "3fa1",
	"./ML.png": "9278",
	"./MM.png": "4133",
	"./MN.png": "a205",
	"./MO.png": "2d8a",
	"./MP.png": "2254",
	"./MQ.png": "d968",
	"./MR.png": "3b80",
	"./MS.png": "75f1",
	"./MT.png": "4827",
	"./MU.png": "7179",
	"./MV.png": "87ac",
	"./MW.png": "98fb",
	"./MX.png": "8e33",
	"./MY.png": "f66d",
	"./MZ.png": "cbe0",
	"./NA.png": "b372",
	"./NC.png": "1b02",
	"./NE.png": "1de7",
	"./NF.png": "f7a3",
	"./NG.png": "2011",
	"./NI.png": "970e",
	"./NL.png": "7f2f",
	"./NO.png": "2f1b",
	"./NP.png": "4c29",
	"./NR.png": "0bcf",
	"./NU.png": "469f",
	"./NZ.png": "3bac",
	"./OM.png": "965a",
	"./PA.png": "ae85",
	"./PE.png": "bed2",
	"./PF.png": "d52b",
	"./PG.png": "8b6c",
	"./PH.png": "92bf",
	"./PK.png": "59d1",
	"./PL.png": "914a",
	"./PM.png": "9591",
	"./PN.png": "fe23",
	"./PR.png": "0b48",
	"./PS.png": "eddc",
	"./PT.png": "7001",
	"./PW.png": "eccd",
	"./PY.png": "b076",
	"./QA.png": "349c",
	"./RE.png": "cbbc",
	"./RO.png": "c340",
	"./RS.png": "20f0",
	"./RU.png": "f432",
	"./RW.png": "be35",
	"./SA.png": "6c55",
	"./SB.png": "fa56",
	"./SC.png": "f583",
	"./SD.png": "be04",
	"./SE.png": "e718",
	"./SG.png": "31f8",
	"./SH.png": "e03a",
	"./SI.png": "12ab",
	"./SJ.png": "f783",
	"./SK.png": "1264",
	"./SL.png": "3eaa",
	"./SM.png": "5c0d",
	"./SN.png": "152f",
	"./SO.png": "9161",
	"./SR.png": "cf6fc",
	"./SS.png": "db48",
	"./ST.png": "0a81",
	"./SV.png": "3218",
	"./SX.png": "70fe",
	"./SY.png": "5ba5",
	"./SZ.png": "33cb",
	"./TA.png": "dbe6",
	"./TC.png": "41a1",
	"./TD.png": "3b54",
	"./TF.png": "3050",
	"./TG.png": "f328",
	"./TH.png": "ef95",
	"./TJ.png": "bdef",
	"./TK.png": "95f1",
	"./TL.png": "cdeb",
	"./TM.png": "862a",
	"./TN.png": "ca3f",
	"./TO.png": "dd72",
	"./TR.png": "2f01",
	"./TT.png": "d640",
	"./TV.png": "89be",
	"./TW.png": "0d5a",
	"./TZ.png": "9b0b",
	"./UA.png": "40ba",
	"./UG.png": "a89c",
	"./UM.png": "87d8",
	"./UN.png": "5686",
	"./US.png": "f3a3",
	"./UY.png": "ff56",
	"./UZ.png": "70d6",
	"./VA.png": "7f01",
	"./VC.png": "0523",
	"./VE.png": "f144",
	"./VG.png": "810e",
	"./VI.png": "7b6c",
	"./VN.png": "129c",
	"./VU.png": "a729",
	"./WF.png": "2dfd",
	"./WS.png": "684a",
	"./XK.png": "79fd",
	"./XX.png": "593b",
	"./YE.png": "0a6a",
	"./YT.png": "6079",
	"./ZA.png": "f2ca",
	"./ZM.png": "49a9",
	"./ZW.png": "7ff4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f6f8";